"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinanceTypeTitles = exports.ConversionRadioTitles = exports.ConversionRadioButtons = exports.AccesoriesTitles = void 0;
// Accesories Titles
var AccesoriesTitles;
(function (AccesoriesTitles) {
    AccesoriesTitles["AMOUNT"] = "Omsetning";
    AccesoriesTitles["PERCENTAGE"] = "% av total";
    AccesoriesTitles["SOLD"] = "Solgt";
})(AccesoriesTitles = exports.AccesoriesTitles || (exports.AccesoriesTitles = {}));
// Conversion Ratio Radio Buttons
var ConversionRadioButtons;
(function (ConversionRadioButtons) {
    ConversionRadioButtons["CARSSOLD"] = "CARSSOLD";
    ConversionRadioButtons["CONVERSIONRATIO"] = "CONVERSIONRATIO";
    ConversionRadioButtons["OFFERSSENT"] = "OFFERSSENT";
})(ConversionRadioButtons = exports.ConversionRadioButtons || (exports.ConversionRadioButtons = {}));
// Conversion Ratio Titles
var ConversionRadioTitles;
(function (ConversionRadioTitles) {
    ConversionRadioTitles["CARSSOLD"] = "Biler solgt";
    ConversionRadioTitles["CONVERSIONRATIO"] = "Konvertering";
    ConversionRadioTitles["OFFERSSENT"] = "Tilbud sendt";
})(ConversionRadioTitles = exports.ConversionRadioTitles || (exports.ConversionRadioTitles = {}));
// Finance Titles
var FinanceTypeTitles;
(function (FinanceTypeTitles) {
    FinanceTypeTitles["CASH"] = "Egenfinansiering";
    FinanceTypeTitles["LEASING"] = "Leasing";
    FinanceTypeTitles["LOAN"] = "L\u00E5n";
})(FinanceTypeTitles = exports.FinanceTypeTitles || (exports.FinanceTypeTitles = {}));
//# sourceMappingURL=statistics.js.map